import React from "react";
import {readableDate} from "../../utils";
import {Form} from "react-bulma-components";


export default function InvoiceSectionRow({invoice}){


    return (
        <tr>
            <td>{invoice.id}</td>
            <td>{invoice.quantity}</td>
            <td>£{invoice.amount}</td>
            <td>£{invoice.no_vat_amount}</td>
            <td>{readableDate(invoice.invoice_date)}</td>
            <td>{invoice.invoice_number}</td>
            <td>{invoice.approved ? "Yes" : "No"}</td>
            <td>{invoice.approver ? invoice.approver.first_name + " " + invoice.approver.last_name : ""}</td>
            <td>
                <Form.Textarea
                    disabled={true}
                    value={invoice.description}
                />
            </td>
            <td>
                <Form.Textarea
                    disabled={true}
                    value={invoice.comments}
                />
            </td>
            <td>
                <Form.Checkbox
                    checked={invoice.hide}
                />
            </td>
        </tr>
    )

}